import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Input,
  ListGroup,
  ListGroupItem,
  Container,
  Row,
  Col,
  Button,
  Pagination,
  PaginationItem,
  Table,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  Label,
  FormGroup,
  Badge,
  Toast
} from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaBarcode, FaBuilding, FaCalendarAlt, FaCartPlus, FaCashRegister, FaCheck, FaCreditCard, FaEdit, FaEnvelope, FaGift, FaGlobe, FaHistory, FaIdCard, FaImage, FaInfoCircle, FaList, FaMapMarkerAlt, FaMinus, FaMoneyBillWave, FaPhone, FaPlus, FaPrint, FaReceipt, FaSearch, FaShoppingCart, FaStore, FaTh, FaTimes, FaTrash, FaUser, FaUserSecret, FaWhatsapp } from 'react-icons/fa'; // Import trash icon
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useTranslation } from "react-i18next";
import { FaSave, FaTrashAlt } from 'react-icons/fa';
import emptyCart from "../../assets/images/empty-cart.png";
import { productActions } from "../../sagas/productSlice";
import { useDispatch, useSelector } from "react-redux";
import { debounce, set } from "lodash";
import { saleActions } from "../../sagas/saleSlice";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../helpers/config";
import amiriNormal from '../../assets/fonts/Amiri-Regular.ttf';
import { clientActions } from "../../sagas/clientSlice";
import ClientForm from "../Client/ClientForm";
import Select from 'react-select/async';
import { components } from 'react-select';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { deliveryActions } from "../../sagas/deliveryNoteSlice";
import { formatPrice } from "../../helpers/utility";


const initialValues = {
  numero: '',
  commandeId: null,
  commandeNumero: '',
  commandeDateCreation: new Date().toISOString(),
  clientId: null,
  clientNom: '',
  clientAdresse: '',
  clientIce: '',
  clientTelephone1: '',
  clientTelephone2: '',
  clientEmail: '',
  deliveryNoteNb: '',
  estLivraisonDirecte: false,
  dateLivraison: new Date().toISOString().split('T')[0],
  lignes: [],
  montantTotalHT: 0,
  montantTotalTTC: 0,
  montantTotalTaxe: 0,
  montantPaye: 0,
  addresseLivraison: '',
  modeReglement: 'ESPECE',
  entrepotId: null,
  transporteurId: null,
  transporteurNom: '',
  transporteurTelephone: '',
  modePaiement: 'ESPECE',
  status: 'EN_ATTENTE',
  accuse: false,
  estFacture: false,
  estCadeau: false,
  estOnline: false,
  numeroFacture: '',
  isClientParticulier: false,
  numeroCheque: '',
  banque: '',
  dateEcheanceCheque: null
};

const validationSchema = Yup.object({
  clientId: Yup.number().nullable(),
  modeReglement: Yup.string()
    .required('Mode de règlement requis')
    .oneOf(['ESPECE', 'CHEQUE', 'VIREMENT', 'TRAITE', 'CARTE_BANCAIRE'], 'Mode de règlement invalide'),
});

const couleurOptions = [
  { value: 'ROUGE', label: 'Rouge', color: '#FF0000' },
  { value: 'VERT', label: 'Vert', color: '#00FF00' },
  { value: 'BLEU', label: 'Bleu', color: '#0000FF' },
  { value: 'JAUNE', label: 'Jaune', color: '#FFFF00' },
  { value: 'ORANGE', label: 'Orange', color: '#FFA500' },
  { value: 'VIOLET', label: 'Violet', color: '#8A2BE2' },
  { value: 'NOIR', label: 'Noir', color: '#000000' },
  { value: 'BLANC', label: 'Blanc', color: '#FFFFFF' },
  { value: 'GRIS', label: 'Gris', color: '#808080' },
  { value: 'MARRON', label: 'Marron', color: '#A52A2A' },
  { value: 'CYAN', label: 'Cyan', color: '#00FFFF' },
  { value: 'MAGENTA', label: 'Magenta', color: '#FF00FF' }
];

const CaisseForm = () => {
  const montantTotalTTC = useSelector(state => state.sales?.montantTotalTTC || 0);
  const montantTotalHT = useSelector(state => state.sales?.montantTotalHT || 0);
  const montantTotalTaxe = useSelector(state => state.sales?.montantTotalTaxe || 0);
  console.log(montantTotalTTC)
  const [cachedOptions, setCachedOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('ESPECE');
  const [amountPaid, setAmountPaid] = useState(montantTotalTTC || 0);
  const [isPassager, setIsPassager] = useState(false);
  const cart = useSelector(state => state.sales?.cart || []);
  const [cartPage, setCartPage] = useState(1);

  const [clearCartModal, setClearCartModal] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const fullName = useSelector(state => state.auth.fullName);
  const { businessName, email, address, telephone } = useSelector(state => state.auth);
  const [displayMode, setDisplayMode] = useState('card'); // or 'card'
  const [showClientModal, setShowClientModal] = useState(false);


  const [client, setClient] = useState({
    nom: '',
    prenom: '',
    cin: '',
    telephone1: '',
    telephone2: '',
    email: '',
    adresse: '',
    ville: 'Casablanca',
    typeClient: 'PARTICULIER',
    codePostal: '',
    plafond: 0,
    entreprise: '', // New field for "Entreprise"
    ice: '',// New field for "ICE",
    active: true,
    solde: 0 // Ce champ sera en lecture seule
  });
  // Add inside component
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    products,
    loading,
    totalPages,
    totalElements,
    pageNumber,
    pageSize,
    error,
  } = useSelector((state) => state.products);
  const unites = useSelector(status => status.products.unites); // Assuming you have a Redux store with unites

  const clients = useSelector(state => state.clients.clients);
  const [criteria, setSearchCriteria] = useState({ query: '' });
  const searchInputRef = useRef(null);
  const [clientModal, setClientModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [showClientForm, setShowClientForm] = useState(false);
  const toggleClearCartModal = () => setClearCartModal(!clearCartModal);
  const [clientErrors, setClientErrors] = useState({});
  const role = useSelector((state) => state.auth.role);
  const isCaissier = role === 'ROLE_CAISSIER';
  const [editedBL, setEditedBL] = useState(null);
  const { list } = useSelector((state) => state.deliveryNotes);

  let { id } = useParams();

  const toggleClientModal = () => {
    setClientModal(!clientModal);
    setShowClientForm(false); // Reset form visibility when modal is toggled
    loadClientOptions(''); // Load clients when modal opens
  }
  // Add new state
  const cartItemsPerPage = 20;
  // Calculate cart pagination
  const cartTotalPages = Math.ceil(cart.length / cartItemsPerPage);
  const cartStartIndex = (cartPage - 1) * cartItemsPerPage;
  const cartEndIndex = cartStartIndex + cartItemsPerPage;
  const currentCartItems = cart.slice(cartStartIndex, cartEndIndex);


  const togglePaymentModal = () => setPaymentModal(!paymentModal);

  useEffect(() => {
    // Fetch supplier options when the component mounts
    loadClientOptions('');
    dispatch(productActions.findAllUnites());

  }, []);

  useEffect(() => {
    if (id) {
      dispatch(saleActions.clearCart());
      setCartPage(1); // Reset cart page
      let bl = list.find(b => b.id == id);
      console.log(bl);
      setEditedBL(bl);
      dispatch(saleActions.setCart(bl));

      // Set selected client if editing and client exists
      if (bl && bl.clientId) {
        // Find client in the clients list
        const client = clients.find(c => c.id === bl.clientId);
        if (client) {
          const clientOption = {
            value: client.id,
            label: client.typeClient === 'PARTICULIER'
              ? `${client.code ? client.code + ' - ' : ''}${client.nom} ${client.prenom}`
              : `${client.code ? client.code + ' - ' : ''}${client.entreprise}`,
            client
          };
          setSelectedClient(clientOption);
        }
      } else {
        setIsPassager(true);
      }
    }
  }, [id, clients]);

  const { t } = useTranslation();


  useEffect(() => {
    dispatch(productActions.findAll({
      search: "",
      page: currentPage - 1,
      size: pageSize,
    }));
  }, []);

  useEffect(() => { setAmountPaid(montantTotalTTC) }, [montantTotalTTC]);


  useEffect(() => {
    // Auto focus on mount
    searchInputRef.current?.focus();

    // Add keyboard shortcut
    const handleKeyDown = (e) => {
      if (e.key === 'F2') {
        e.preventDefault();
        searchInputRef.current?.focus();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [products]);


  const handleClientAdded = (newClient) => {
    loadClientOptions("");
    setSelectedClient(newClient);
    setShowClientForm(false);
    toggleClientModal();
  };

  const loadClientOptions = async (inputValue) => {
    return new Promise((resolve) => {
      dispatch(clientActions.search({
        query: inputValue,
        onSuccess: (data) => {
          console.log(data);
          const options = data.content.map(client => {
            let label = '';
            if (client.typeClient === 'PARTICULIER') {
              label = (client.code ? client.code + ' - ' : '') + client.nom + ' ' + client.prenom;
            } else {
              label = (client.code ? client.code + ' - ' : '') + client.entreprise;
            }
            return {
              value: client.id,
              label,
              client
            };
          });
          setCachedOptions(options); // Cache the options
          resolve(options);
        }
      }));
    });
  };

  const handleAddToCart = (product) => {
    //dispatch(saleActions.addToCart(product));
  };

  const handleSelectClient = (client) => {
    setSelectedClient(client);
    toggleClientModal();
  };

  const handleInputChange = useCallback((index, event) => {
    const { name, value } = event.target;
    dispatch(saleActions.handleInputChange({ index, name, value }));
  }, [dispatch]);


  const handleRemoveFromCart = useCallback((productId) => {
    console.log(productId)
    dispatch(saleActions.removeFromCart(productId));
    setCartPage((prevPage) => {
      // Calculate new cart length after removal
      const newCartLength = cart.length - 1;
      const newTotalPages = Math.ceil(newCartLength / cartItemsPerPage);

      // If previous page is out of range, move to last valid page (at least 1)
      return prevPage > newTotalPages ? Math.max(1, newTotalPages) : prevPage;
    });
  }, [cart, cartItemsPerPage, dispatch]);

  // Debounced search function
  const debouncedSearch = useCallback(
    debounce((query) => {
      setIsSearching(true);
      dispatch(productActions.findAll({
        search: query,
        page: currentPage - 1,
        size: pageSize,
      }));
    }, 1000), // Wait 500ms after last keystroke
    []
  );

  // Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    debouncedSearch(value);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };



  const handleClearCart = () => {
    Swal.fire({
      title: t('cart.clearConfirmMessage'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(saleActions.clearCart());
        setCartPage(1); // Reset cart page

      }
    });
  };

  const generatePDF = async () => {
    try {
      // Create PDF with 80mm thermal printer dimensions
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: [80, 300] // 80mm width, longer for customer receipt
      });

      doc.setFont('helvetica');

      let yPosition = 5;
      const pageWidth = 80;
      const margin = 3;
      const contentWidth = pageWidth - (margin * 2);

      // Business Header
      doc.setFontSize(14);
      doc.setFont('helvetica', 'bold');
      doc.text(businessName || 'MatjarPos', pageWidth / 2, yPosition, { align: 'center' });
      yPosition += 6;

      // Business Address
      if (address) {
        doc.setFontSize(8);
        doc.setFont('helvetica', 'normal');
        const addressLines = doc.splitTextToSize(address, contentWidth);
        addressLines.forEach((line, index) => {
          doc.text(line, pageWidth / 2, yPosition + (index * 3), { align: 'center' });
        });
        yPosition += (addressLines.length * 3) + 3;
      }

      // Business Contact Info
      doc.setFontSize(7);
      if (telephone) {
        doc.text(`Tel: ${telephone}`, pageWidth / 2, yPosition, { align: 'center' });
        yPosition += 3;
      }
      if (email) {
        doc.text(`Email: ${email}`, pageWidth / 2, yPosition, { align: 'center' });
        yPosition += 5;
      }

      // Receipt Title
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text('RECU DE VENTE', pageWidth / 2, yPosition, { align: 'center' });
      yPosition += 6;

      // Separator line
      doc.setLineWidth(0.2);
      doc.line(margin, yPosition, pageWidth - margin, yPosition);
      yPosition += 4;

      // Receipt Details
      doc.setFontSize(8);
      doc.setFont('helvetica', 'bold');
      doc.text('Recu No:', margin, yPosition);
      doc.setFont('helvetica', 'normal');
      doc.text(receiptData?.numero || '---', margin + 20, yPosition);
      yPosition += 4;

      doc.setFont('helvetica', 'bold');
      doc.text('Date:', margin, yPosition);
      doc.setFont('helvetica', 'normal');
      const currentDate = receiptData?.paidAt || 'N/A';
      doc.text(currentDate, margin + 12, yPosition);
      yPosition += 4;

      doc.setFont('helvetica', 'bold');
      doc.text('Caissier:', margin, yPosition);
      doc.setFont('helvetica', 'normal');
      doc.text(receiptData?.paidBy || '---', margin + 20, yPosition);
      yPosition += 6;

      // Customer Information
      if (selectedClient?.label) {
        doc.setFont('helvetica', 'bold');
        doc.text('Client:', margin, yPosition);
        doc.setFont('helvetica', 'normal');
        const clientLines = doc.splitTextToSize(selectedClient.label, contentWidth - 15);
        clientLines.forEach((line, index) => {
          doc.text(line, margin + 15, yPosition + (index * 3));
        });
        yPosition += (clientLines.length * 3) + 3;
      } else {
        doc.setFont('helvetica', 'normal');
        doc.text('Client: Passager', margin, yPosition);
        yPosition += 5;
      }

      // Separator line
      doc.setLineWidth(0.1);
      doc.line(margin, yPosition, pageWidth - margin, yPosition);
      yPosition += 3;

      // Items Header
      doc.setFontSize(7);
      doc.setFont('helvetica', 'bold');
      doc.text('Article', margin, yPosition);
      doc.text('Qte', pageWidth - 35, yPosition);
      doc.text('Prix', pageWidth - 22, yPosition);
      doc.text('Total', pageWidth - 8, yPosition, { align: 'right' });
      yPosition += 3;

      doc.setLineWidth(0.05);
      doc.line(margin, yPosition, pageWidth - margin, yPosition);
      yPosition += 3;

      // Items List
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);

      let subtotal = 0;

      receiptData?.lignes?.forEach((item, index) => {
        // Check if we need a new page
        if (yPosition > 250) {
          doc.addPage([80, 300]);
          yPosition = 5;
        }

        // Item name (split if too long)
        const itemName = item.articleNom.length > 25 ? item.articleNom.substring(0, 22) + '...' : item.articleNom;
        doc.text(itemName, margin, yPosition);
        yPosition += 5;

        // Item code (smaller text)
        doc.setFontSize(8);
        doc.text(`Code: ${item.articleCode}`, margin + 2, yPosition);
        yPosition += 3;

        // Quantity, unit price, and total on same line
        doc.setFontSize(6);
        const uniteLibelle = (() => {
          const libelle = unites.find(u => u.code === item.unite)?.libelle;
          // if (libelle === 'METRE') return 'M';
          // if (libelle === 'COUPON') return 'CP';
          return libelle;
        })();

        doc.text(`${item.quantiteLivree} ${uniteLibelle}`, pageWidth - 40, yPosition - 2);
        doc.setFontSize(7);

        doc.text(`${formatPrice(item.prixUnitaireTTC, false)}`, pageWidth - 27, yPosition - 2);
        doc.text(`${formatPrice(item.montantTTC, false)}`, pageWidth - 3, yPosition - 2, { align: 'right' });

        yPosition += 2;
        subtotal += parseFloat(item.montantTTC);

        // Separator line between items
        if (index < receiptData.lignes.length - 1) {
          doc.setLineWidth(0.02);
          doc.line(margin + 5, yPosition, pageWidth - margin - 5, yPosition);
          yPosition += 4;
        }
      });

      yPosition += 3;

      // Totals Section
      doc.setLineWidth(0.1);
      doc.line(margin, yPosition, pageWidth - margin, yPosition);
      yPosition += 4;

      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');

      // Subtotal
      doc.text('Sous-total:', margin, yPosition);
      doc.text(formatPrice(receiptData?.montantTotalHT || subtotal, false), pageWidth - 8, yPosition, { align: 'right' });
      yPosition += 4;

      // Tax if applicable
      if (receiptData?.montantTotalTaxe && receiptData.montantTotalTaxe > 0) {
        doc.text('TVA:', margin, yPosition);
        doc.text(formatPrice(receiptData.montantTotalTaxe, false), pageWidth - 8, yPosition, { align: 'right' });
        yPosition += 4;
      }

      // Total
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      doc.text('TOTAL:', margin, yPosition);
      doc.text(formatPrice(receiptData?.montantTotalTTC || subtotal, false), pageWidth - 8, yPosition, { align: 'right' });
      yPosition += 6;

      // Payment Information
      doc.setLineWidth(0.1);
      doc.line(margin, yPosition, pageWidth - margin, yPosition);
      yPosition += 4;

      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');

      // Payment method
      const paymentMethodText = formik.values.modePaiement === 'ESPECE' ? 'Espèces' :
        formik.values.modePaiement === 'CARTE_BANCAIRE' ? 'Carte Bancaire' :
          formik.values.modePaiement;
      doc.text(`Paiement: ${paymentMethodText}`, margin, yPosition);
      yPosition += 4;

      // Amount paid
      if (formik.values.montantPaye) {
        doc.text('Montant reçu:', margin, yPosition);
        doc.text(formatPrice(formik.values.montantPaye, false), pageWidth - 8, yPosition, { align: 'right' });
        yPosition += 4;

        // Change (only for cash payments)
        if (formik.values.modePaiement === 'ESPECE' && formik.values.montantPaye > montantTotalTTC) {
          doc.text('Monnaie:', margin, yPosition);
          doc.text(formatPrice(formik.values.montantPaye - montantTotalTTC, false), pageWidth - 8, yPosition, { align: 'right' });
          yPosition += 6;
        }
      }

      // Footer Messages
      yPosition += 5;
      doc.setLineWidth(0.1);
      doc.line(margin, yPosition, pageWidth - margin, yPosition);
      yPosition += 4;

      doc.setFontSize(9);
      doc.setFont('helvetica', 'bold');
      doc.text('MERCI DE VOTRE VISITE!', pageWidth / 2, yPosition, { align: 'center' });
      yPosition += 5;

      doc.setFontSize(7);
      doc.setFont('helvetica', 'normal');
      doc.text('Gardez votre reçu', pageWidth / 2, yPosition, { align: 'center' });
      yPosition += 3;
      doc.text('Echange possible sous 7 jours', pageWidth / 2, yPosition, { align: 'center' });
      yPosition += 5;

      // QR Code placeholder or additional info
      doc.setFontSize(6);
      doc.text('Powered by MatjarPos', pageWidth / 2, yPosition, { align: 'center' });



      // Also open in new window for immediate printing
      const pdfBlob = doc.output('blob');
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl);

    } catch (error) {
      console.error("Error generating customer receipt:", error);
      Swal.fire({
        icon: 'error',
        title: 'Erreur',
        text: 'Erreur lors de la génération du reçu client'
      });
    }
  };


  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      dispatch(productActions.findAll({
        search: searchTerm,
        page: currentPage - 1,
        size: pageSize,
      }));
    }
  };

  const DisplayToggle = () => (
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div className="btn-group">
        <Button
          color={displayMode === 'table' ? 'primary' : 'light'}
          onClick={() => setDisplayMode('table')}
          size="sm"
        >
          <FaList className="me-1" /> {t('common.table')}
        </Button>
        <Button
          color={displayMode === 'card' ? 'primary' : 'light'}
          onClick={() => setDisplayMode('card')}
          size="sm"
        >
          <FaTh className="me-1" /> {t('common.cards')}
        </Button>
      </div>

      <div className="d-flex align-items-center gap-3">
        {/* <small className="text-muted">
          {t('product.showing', {
            start: (currentPage - 1) * pageSize + 1,
            end: Math.min(currentPage * pageSize, totalElements),
            total: totalElements,
            currentPage: currentPage,
            totalPages: totalPages
          })}
        </small> */}

        <div className="d-flex align-items-center gap-2">
          <Button color="light" size="sm" onClick={() => handlePageChange(1)} disabled={currentPage === 1}>
            <FaAngleDoubleLeft />
          </Button>
          <Button color="light" size="sm" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
            <FaAngleLeft />
          </Button>

          <span className="mx-2">
            {currentPage} / {totalPages}
          </span>

          <Button color="light" size="sm" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
            <FaAngleRight />
          </Button>
          <Button color="light" size="sm" onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>
            <FaAngleDoubleRight />
          </Button>
        </div>
      </div>
    </div>
  );

  const TableView = () => (
    <>
      <div className="cart-container" style={{
        height: '550px',
        overflowY: 'auto'
      }}>
        <Table bordered hover>
          <thead>
            <tr>
              <th>{t('product.code')}</th>
              <th style={{ width: 250 }}>{t('product.description')}</th>
              <th>{t('product.salePrice')}</th>
            </tr>
          </thead>
          <tbody>
            {!products || (products ?? []).length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  <div className="text-muted">
                    {t('product.noProducts')}
                  </div>
                </td>
              </tr>
            ) : ((products ?? []).map((product) => (
              <tr key={product.id} onClick={() => handleAddToCart(product)}>
                <td>{product.code}</td>
                <td>
                  {product.categorieLibelle} - {product.libelle}
                </td>
                <td className="align-middle text-end">
                  {formatPrice(product.prixVenteTTC1, false)} / {unites.find(u => u.code == product.unite).libelle}
                </td>
              </tr>
            ))
            )}
          </tbody>
        </Table>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <small className="text-muted">
          {t('product.showing', {
            start: (currentPage - 1) * pageSize + 1,
            end: Math.min(currentPage * pageSize, totalElements),
            total: totalElements,
            currentPage: currentPage,
            totalPages: totalPages
          })}
        </small>
      </div>
    </>
  );

  const CardView = () => (
    <div style={{ height: '600px', overflowY: 'auto', padding: '0.25rem' }}>
      <Row xs={2} md={3} lg={3} className="g-2">
        {(!products || products.length === 0) && (
          <Col xs={12} className="text-center py-4">
            <div className="text-muted">
              <FaImage size={32} className="mb-2 opacity-50" />
              <p className="mb-0 small">{t('product.noProducts')}</p>
            </div>
          </Col>
        )}
        {products.map(product => (
          <Col key={product.id}>
            <Card
              disabled
              onClick={() => handleAddToCart(product)}
              style={{
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                borderRadius: '8px',
                minHeight: '220px' // Slightly increased to accommodate colors
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.12)';
                e.currentTarget.style.borderColor = '#0d6efd';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.08)';
                e.currentTarget.style.borderColor = 'rgba(0, 0, 0, 0.05)';
              }}
            >
              {/* Subtle hover indicator - only on image area */}
              <div
                className="position-absolute d-flex align-items-center justify-content-center text-white opacity-0 product-hover-indicator"
                style={{
                  top: '0',
                  left: '0',
                  right: '0',
                  height: '100px', // Only cover the image area
                  background: 'rgba(13, 110, 253, 0.15)',
                  backdropFilter: 'blur(1px)',
                  transition: 'opacity 0.2s ease',
                  borderRadius: '8px 8px 0 0',
                  zIndex: 5
                }}
              >
                <div className="text-center">
                  <FaCartPlus size={16} className="text-primary bg-white rounded-circle p-1" style={{ width: '28px', height: '28px' }} />
                </div>
              </div>

              {/* Compact image container */}
              <div
                className="position-relative overflow-hidden"
                style={{
                  height: '100px',
                  borderRadius: '8px 8px 0 0'
                }}
              >
                {product.photo ? (
                  <img
                    src={`${config.baseURL}${product.photo}`}
                    alt={product.libelle}
                    className="w-100 h-100"
                    style={{
                      objectFit: 'cover',
                      transition: 'transform 0.2s ease'
                    }}
                  />
                ) : (
                  <div
                    className="w-100 h-100 d-flex align-items-center justify-content-center"
                    style={{
                      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
                    }}
                  >
                    <FaImage size={24} className="text-muted opacity-50" />
                  </div>
                )}

                {/* Compact stock badge */}
                {product.stock !== undefined && (
                  <Badge
                    color={product.stock > 10 ? 'success' : product.stock > 0 ? 'warning' : 'danger'}
                    className="position-absolute top-0 end-0 m-1"
                    style={{ fontSize: '0.6rem', padding: '0.2rem 0.4rem', zIndex: 6 }}
                  >
                    {product.stock > 0 ? product.stock : '0'}
                  </Badge>
                )}
              </div>

              {/* Compact card body */}
              <CardBody className="p-2 d-flex flex-column">
                {/* Product code - smaller */}
                {product.code && (
                  <div className="mb-1">
                    <small className="text-muted" style={{ fontSize: '0.65rem' }}>
                      {product.code}
                    </small>
                  </div>
                )}

                {/* Compact product title */}
                <div
                  className="product-title-compact mb-1 fw-semibold text-dark lh-sm"
                  style={{
                    fontSize: '0.75rem',
                    minHeight: '2.25rem',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                  }}
                  title={product.libelle}
                >
                  {product.categorieLibelle} - {product.libelle}
                </div>

                {/* Colors display */}
                {product.couleurs && product.couleurs.length > 0 && (
                  <div className="colors-display-sales mb-1">
                    <div className="d-flex flex-wrap align-items-center gap-1">
                      {product.couleurs.slice(0, 5).map((couleur, index) => {
                        const couleurOption = couleurOptions.find(c => c.value === couleur);
                        return (
                          <span
                            key={`${product.id}-${couleur}-${index}`}
                            className="color-dot-sales"
                            style={{
                              backgroundColor: couleurOption?.color || '#6c757d',
                              border: couleurOption?.color === '#FFFFFF' ? '1px solid #dee2e6' : '1px solid rgba(0,0,0,0.1)'
                            }}
                            title={couleurOption?.label || couleur}
                          ></span>
                        );
                      })}
                      {product.couleurs.length > 5 && (
                        <span className="color-more-sales">
                          +{product.couleurs.length - 5}
                        </span>
                      )}
                    </div>
                  </div>
                )}

                {/* Genre badge */}
                {product.genre && (
                  <div className="mb-1">
                    <Badge
                      color={product.genre === 'HOMME' ? 'primary' : 'pink'}
                      style={{ fontSize: '0.6rem', padding: '0.2rem 0.4rem' }}
                    >
                      {t(`product.${product.genre.toLowerCase()}`)}
                    </Badge>
                  </div>
                )}

                {/* Compact price section */}
                <div className="mt-auto">
                  <div className="d-flex align-items-end justify-content-between">
                    <div className="flex-grow-1">
                      <div
                        className="fw-bold text-primary"
                        style={{ fontSize: '0.8rem', lineHeight: '1' }}
                      >
                        {formatPrice(product.prixVenteTTC1)}  / {unites.find(u => u.code === product.unite)?.libelle || product.unite}
                      </div>
                      <small
                        className="text-muted d-block"
                        style={{ fontSize: '0.6rem', lineHeight: '1' }}
                      >

                      </small>
                    </div>

                    {/* Compact add button */}
                    <Button
                      color="primary"
                      size="sm"
                      className="rounded-circle p-0 border-0 ms-1"
                      style={{
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.7rem'
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleAddToCart(product);
                      }}
                    >
                      <FaPlus size={8} />
                    </Button>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Updated styles */}
      <style jsx>{`
      .product-card-compact:hover .product-hover-indicator {
        opacity: 1 !important;
      }
      
      .product-card-compact {
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
        border: 1px solid rgba(0, 0, 0, 0.05);
      }
      
      .product-title-compact {
        word-break: break-word;
        color: #2c3e50;
      }
      
      .colors-display-sales {
        min-height: 16px;
      }
      
      .color-dot-sales {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        display: inline-block;
        cursor: pointer;
        transition: transform 0.1s ease;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
      }
      
      .color-dot-sales:hover {
        transform: scale(1.3);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
      }
      
      .color-more-sales {
        font-size: 0.6rem;
        color: #6c757d;
        font-weight: 500;
        margin-left: 2px;
      }
      
      @media (max-width: 768px) {
        .product-card-compact {
          min-height: 200px;
        }
        
        .product-hover-indicator {
          height: 80px !important;
        }
        
        .color-dot-sales {
          width: 10px;
          height: 10px;
        }
      }
      
      @media (max-width: 576px) {
        .product-card-compact {
          min-height: 180px;
        }
        
        .product-hover-indicator {
          height: 70px !important;
        }
        
        .color-dot-sales {
          width: 8px;
          height: 8px;
        }
        
        .color-more-sales {
          font-size: 0.55rem;
        }
      }
    `}</style>
    </div>
  );


  const handleEncaisserCommande = (values) => {
    if (!selectedClient && !isPassager) {
      Swal.fire({
        icon: 'warning',
        title: t('facture.clientRequired'),
        text: t('facture.clientRequiredMessage')
      });
      return;
    }

    const saleData = {
      id: editedBL.id,
      numero: editedBL.numero,
      estCadeau: values.estCadeau,
      estOnline: values.estOnline,
      modePaiement: values.modePaiement,
      montantTotalHT: montantTotalHT,
      montantTotalTTC: montantTotalTTC,
      montantTotalTaxe: montantTotalTaxe,
      montantPaye: values.montantPaye < montantTotalTTC ? values.montantPaye : montantTotalTTC,
      status: 'PAYE',
      lignes: cart.map(item => ({
        articleId: item.articleId,
        articleCode: item.articleCode,
        articleNom: item.articleNom,
        quantiteLivree: item.quantite,
        unite: unites.find(u => u.code === item.unite).libelle,
        prixUnitaireTTC: item.prixUnitaireTTC,
        prixUnitaireHT: item.prixUnitaireHT,
        montantHT: item.montantHT,
        montantTTC: item.montantTTC,
        tauxTVA: item.tauxTVA
      }))
    };

    let payload = {
      id: id,
      data: saleData,
      onSuccess: (data) => {
        Swal.fire({
          icon: 'success',
          title: t('common.saved'),
          text: t('bonLivraison.savedSuccess'),
        });
        setReceiptData(data);
        setModal(true);
        dispatch(saleActions.clearCart());
        setPaymentModal(false);
      },
      onError: (error) => {
        Swal.fire({
          icon: 'error',
          title: t('sale.error'),
          text: error.message || t('sale.errorMessage')
        });
      }
    };

    dispatch(deliveryActions.encaisserBL(payload));
  };


  // Add formik hook
  const formik = useFormik({
    initialValues: {
      ...initialValues,
      estCadeau: editedBL?.estCadeau || false,
      estOnline: editedBL?.estOnline || false,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      handleEncaisserCommande(values);
    }
  });


  return (
    <Container fluid>
      {id && editedBL && (
        <Row className="mb-3">
          <Col>
            <Card className="border-primary">
              <CardBody className="py-3">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <FaEdit className="text-primary me-2" size={20} />
                    <div>
                      <h6 className="mb-1 text-primary fw-bold">
                        Encaissement Commande N° {editedBL.numero}
                      </h6>
                      <div className="d-flex align-items-center gap-3 text-muted">
                        <small>
                          <FaUser className="me-1" />
                          Client: <span className="fw-semibold">{editedBL.clientNom || 'Client passager'}</span>
                        </small>
                        {editedBL.estCadeau && <small>
                          <FaGift className="me-1" />
                          Cadeau: <span className="fw-semibold">{'Oui'}</span>
                        </small>}
                        {editedBL.estOnline && <small>
                          <FaGlobe className="me-1" />
                          Vente en ligne: <span className="fw-semibold">{'Oui'}</span>
                        </small>}
                        <small>
                          <FaCalendarAlt className="me-1" />
                          Date: <span className="fw-semibold">{editedBL.createdAt}</span>
                        </small>
                        <small>
                          <FaInfoCircle className="me-1" />
                          Statut: <Badge
                            color={
                              editedBL.status === 'LIVRE' ? 'success' :
                                editedBL.status === 'EN_PREPARATION' ? 'warning' :
                                  editedBL.status === 'ANNULE' ? 'danger' : 'info'
                            }
                            className="ms-1"
                          >
                            {editedBL.status}
                          </Badge>
                        </small>
                      </div>
                    </div>
                  </div>
                  {/* <div className="d-flex align-items-center gap-2">
                          <Button
                            color="outline-secondary"
                            size="sm"
                            onClick={() => generatePreparationTicket()}
                          >
                            <FaTimes className="me-1" size={12} />
                            Imprimer
                          </Button>
                        </div>} */}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
      <Row>
        {/* Product List */}
        <Col md={6} className="pe-4">
          <Card className="shadow-sm h-100">
            <CardBody>
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">{t('common.loading')}</span>
                  </div>
                  <div className="mt-2 text-muted">
                    {t('common.loadingData')}
                  </div>
                </div>
              ) : (<>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  {/* Search Input - Left Side */}
                  <div className="position-relative flex-grow-1 me-3">
                    <Input
                      innerRef={searchInputRef}
                      type="text"
                      placeholder={t('product.searchFocusHint')}
                      value={searchTerm.toUpperCase()}
                      onKeyDown={handleSearchKeyDown}
                      onChange={handleSearchChange}
                      className={`ps-4 pe-5 ${isSearching ? 'searching' : ''}`}
                      title={t('product.searchShortcut')}
                    />
                    <FaSearch
                      style={{
                        position: 'absolute',
                        left: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: '#adb5bd'
                      }}
                      size={14}
                    />
                    <FaBarcode
                      style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: '#adb5bd'
                      }}
                      size={20}
                      title={t('product.scanHint')}
                    />
                  </div>
                  {/* <Button
                    color="primary"
                    size="sm"
                    className="d-flex align-items-center"
                    onClick={() => navigate('/sales/history')}
                    title={t('sale.viewHistory')}
                  >
                    <FaHistory className="me-2" />
                    {t('sale.viewHistory')}
                  </Button> */}
                </div>
                <DisplayToggle />
                {displayMode === 'table' ? <TableView /> : <CardView />}
              </>)}
            </CardBody>
          </Card>
        </Col>
        <Col md={6} className="ps-4 border-start">
          <Card className="shadow-sm h-100">
            <div className="card-header bg-light d-flex align-items-center justify-content-between py-3">
              <div className="d-flex align-items-center">
                <div className="position-relative me-2">
                  <FaShoppingCart size={18} className="text-primary" />
                  {cart.length > 0 && (
                    <Badge
                      color="danger"
                      pill
                      className="position-absolute d-flex align-items-center justify-content-center"
                      style={{
                        top: '-6px',
                        right: '-10px',
                        fontSize: '0.65rem',
                        width: '16px',
                        height: '16px',
                        padding: 0
                      }}
                    >
                      {cart.length}
                    </Badge>
                  )}
                </div>
                <h6 className="mb-0 fw-bold me-3">{t('cart.title')}</h6> {/* Adjusted margin */}

              </div>
              {cart.length > 0 && (
                <Button
                  color="danger"
                  size="sm"
                  onClick={handleClearCart}
                  disabled
                >
                  <FaTrash size={12} />
                </Button>
              )}
            </div>
            <CardBody className="p-0">

              {cart.length === 0 ? (
                <div className="text-center py-5">
                  <img
                    src={emptyCart}
                    alt="Empty Cart"
                    style={{
                      width: '150px',
                      opacity: '0.5',
                      marginBottom: '1rem'
                    }}
                  />
                  <p className="text-muted">{t('cart.empty')}</p>
                </div>
              ) : (
                <>
                  <Card className="mb-3">
                    <CardBody className="p-0">
                      <div className="cart-container" style={{
                        height: '350px',
                        overflowY: 'auto',
                        fontSize: '0.9rem'
                      }}>
                        <Table hover responsive className="mb-0 cart-table">
                          <thead className="bg-light position-sticky top-0" style={{ zIndex: 1 }}>
                            <tr>
                              <th style={{ width: 150 }}>{t('devis.article')}</th>
                              <th>{t('devis.quantite')}</th>
                              <th>{t('devis.unite')}</th>
                              {isCaissier && <th>{t('devis.prixUnitaireTTC')}</th>}
                              {isCaissier && <th>{t('devis.montantTTC')}</th>}
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentCartItems.map((item, index) => (
                              <tr key={item.id} className="align-middle">
                                <td style={{ maxWidth: '300px' }}>
                                  <Input
                                    type="text"
                                    name="articleNom"
                                    value={item.articleNom}
                                    onChange={(event) => handleInputChange(index, event)}
                                    disabled
                                  />
                                </td>
                                <td>
                                  <Input
                                    type="number"
                                    name="quantite"
                                    value={item.quantite}
                                    onChange={(event) => handleInputChange(index, event)}
                                    disabled
                                  />
                                </td>
                                <td >
                                  <Input
                                    type="text"
                                    name="unite"
                                    value={unites.find(u => u.code === item.unite).libelle}
                                    onChange={(event) => handleInputChange(index, event)}
                                    disabled
                                  />
                                </td>
                                {isCaissier && <td >
                                  <Input
                                    type="number"
                                    name="prixUnitaireTTC"
                                    value={item.prixUnitaireTTC}
                                    onChange={(event) => handleInputChange(index, event)}

                                  />
                                </td>}
                                {isCaissier && <td>
                                  <Input
                                    type="text"
                                    name="montantTTC"
                                    value={formatPrice(item.montantTTC, false)}
                                    disabled
                                  />
                                </td>}
                                {/* <td>
                                  {item.appliedTaxRate * 100}%
                                </td> */}
                                <td style={{ width: '40px' }}>
                                  <Button
                                    color="link"
                                    className="p-0 text-danger"
                                    onClick={() => handleRemoveFromCart(item.articleId)}
                                    disabled
                                  >
                                    <FaTrash size={12} />
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </CardBody>
                  </Card>
                  <div className="border-top p-3">
                    {isCaissier && <>
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="fs-5 fw-bold text-muted ps-2">
                          {t('cart.totalTTC')}
                        </div>
                        <div className="fs-4 fw-bold text-primary pe-2">
                          {formatPrice(montantTotalTTC)}
                        </div>
                      </div>
                    </>}
                    <Button
                      color="success"
                      className="w-100 mt-3 py-2"
                      size="xl"
                      onClick={() => {
                        if (!cart.length) {
                          Swal.fire({
                            icon: 'warning',
                            title: t('cart.empty'),
                            text: t('cart.emptyMessage')
                          });
                          return;
                        }
                        setPaymentModal(true);
                      }}
                    >
                      <FaShoppingCart className="me-2" />
                      {t('cart.checkout')}
                    </Button>
                  </div>
                </>
              )}
            </CardBody>
          </Card>
        </Col>

      </Row>

      {/* Receipt Modal */}
      <Modal isOpen={modal} toggle={() => setModal(false)}>
        <ModalHeader toggle={() => setModal(false)}>
          {t('receipt.title')}
        </ModalHeader>
        <ModalBody>
          <div
            id="receipt-content"
            className="p-4 bg-white shadow-sm rounded"
            style={{ width: '100%' }}
          >
            {/* Header */}
            <div className="text-center mb-4">
              <h5 className="mb-2">
                <FaStore className="me-2 text-secondary" />
                {businessName}
              </h5>
              <small className="d-block mb-2">
                <FaMapMarkerAlt className="me-1 text-secondary" />
                {address}
              </small>
              <div className="d-flex justify-content-center align-items-center gap-3">
                {telephone && (
                  <small>
                    <FaWhatsapp className="me-1 text-secondary" />
                    {telephone}
                  </small>
                )}
                <small>
                  <FaEnvelope className="me-1 text-secondary" />
                  {email}
                </small>
              </div>
            </div>

            <hr />

            {/* Receipt Details */}
            <div className="mb-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <FaReceipt className="me-2 text-secondary" />
                  <span className="fw-bold">{t('sale.receipt.receiptNo')} </span>
                  {receiptData?.numero}
                </div>
                <div>
                  <FaCalendarAlt className="me-2 text-secondary" />
                  <span className="fw-bold">{t('sale.receipt.date')} </span>
                  {receiptData?.dateLivraison}
                </div>
              </div>
              <div>
                <FaUser className="me-2 text-secondary" />
                <span className="fw-bold">{t('sale.receipt.cashier')} </span>
                {fullName}
              </div>
            </div>

            <hr />

            {/* Products Table */}
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>{t('product.description')}</th>
                  <th className="text-end">{t('sale.receipt.price')}</th>
                  <th className="text-end">{t('sale.receipt.quantity')}</th>
                  <th className="text-end">{t('sale.receipt.unite')}</th>
                  <th className="text-end">{t('sale.receipt.total')}</th>
                </tr>
              </thead>
              <tbody>
                {receiptData && receiptData.lignes.map((item, index) => (
                  <tr key={index}>
                    <td>{item.articleNom}</td>
                    <td className="text-end">{formatPrice(item.prixUnitaireTTC, false)}</td>
                    <td className="text-end">{item.quantiteLivree}</td>
                    <td className="text-end">{unites.find(u => u.code === item.unite).libelle}</td>
                    <td className="text-end">{formatPrice(item.montantTTC, false)}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <hr />

            {/* Totals */}
            <div className="text-end mb-4">
              {/* <div className="mb-2">
                <span className="fw-bold me-3">{t('sale.receipt.subtotal')}</span>
                {formatPrice(receiptData.totalAmount)}
              </div> */}
              {/* <div className="mb-2">
                <span className="fw-bold me-3">{t('sale.receipt.tax')}</span>
                {formatPrice(0)}
              </div> */}
              <div className="mb-2">
                <span className="fw-bold me-3">{t('sale.receipt.total')}</span>
                {formatPrice(receiptData?.montantTotalTTC)}
              </div>

            </div>

            {/* Footer */}
            <div className="text-center mt-4">
              <p className="mb-1">{t('sale.receipt.thankYou')}</p>
              <small className="text-muted">{t('sale.receipt.footer')}</small>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={generatePDF}>
            <FaPrint className="me-1" />
            {t('receipt.printBill')}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Simplified Payment Modal */}
      <Modal isOpen={paymentModal} toggle={togglePaymentModal} size="lg" className="payment-modal">
        <ModalHeader toggle={togglePaymentModal} className="bg-success text-white border-0">
          <div className="d-flex align-items-center">
            <FaCashRegister className="me-2" size={20} />
            <span className="fw-bold">{t('payment.processPayment')}</span>
          </div>
        </ModalHeader>
        <ModalBody className="p-4">
          {/* Order Summary Card */}
          <Card className="border-success border-opacity-25 mb-4">
            <CardBody className="p-3">
              <Row className="align-items-center">
                <Col md={6}>
                  <div className="d-flex align-items-center">
                    <FaReceipt className="text-success me-2" size={20} />
                    <div>
                      <small className="text-muted d-block">{t('payment.orderNumber')}</small>
                      <h5 className="mb-0 fw-bold text-primary">{editedBL?.numero}</h5>
                    </div>
                  </div>
                </Col>
                <Col md={6} className="text-end">
                  <div>
                    <small className="text-muted d-block">{t('payment.totalAmount')}</small>
                    <h4 className="mb-0 fw-bold text-success">{formatPrice(montantTotalTTC)}</h4>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Row className="mb-4">
            <Col md={7}>
              <Card className="border-0 bg-light h-100">
                <CardBody className="p-3">
                  <div className="d-flex align-items-center">
                    <FaUser className="text-muted me-2" size={16} />
                    <div>
                      <small className="text-muted">{t('payment.customer')}</small>
                      <div className="fw-semibold">
                        {selectedClient?.label || t('payment.walkInCustomer')}
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md={5} className="d-flex align-items-center">
              <Card className="border-0 h-100 w-100">
                <CardBody className="p-3 d-flex align-items-center">
                  <div className="form-check form-switch d-inline-flex align-items-center">
                    <Input
                      type="checkbox"
                      name="estCadeau"
                      id="estCadeau"
                      checked={formik.values.estCadeau}
                      disabled
                      className="form-check-input"
                    />
                    <Label className="form-check-label fw-bold ms-2 mb-0" htmlFor="estCadeau">
                      <FaGift className="me-2 text-warning" size={16} />
                      {t('payment.giftOption')}
                    </Label>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Payment Method Selection */}
          <Card className="border-0 mb-4">
            <CardBody className="p-3">
              <Label className="fw-bold mb-3 d-flex align-items-center">
                <FaMoneyBillWave className="me-2 text-success" size={16} />
                {t('payment.method')}
              </Label>

              <Row>
                <Col md={6}>
                  <div className="payment-method-card">
                    <input
                      type="radio"
                      className="btn-check"
                      name="modePaiement"
                      id="espece"
                      value="ESPECE"
                      checked={formik.values.modePaiement === 'ESPECE'}
                      onChange={() => {
                        formik.setFieldValue('modePaiement', 'ESPECE');
                        formik.setFieldValue('montantPaye', montantTotalTTC);
                      }}
                    />
                    <label className="btn btn-outline-success w-100 p-3" htmlFor="espece">
                      <div className="text-center">
                        <FaMoneyBillWave size={24} className="mb-2" />
                        <div className="fw-bold">{t('facture.modeReglement.espece')}</div>
                        <small className="text-muted">{t('payment.cashDescription')}</small>
                      </div>
                    </label>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="payment-method-card">
                    <input
                      type="radio"
                      className="btn-check"
                      name="modePaiement"
                      id="carte"
                      value="CARTE_BANCAIRE"
                      checked={formik.values.modePaiement === 'CARTE_BANCAIRE'}
                      onChange={() => {
                        formik.setFieldValue('modePaiement', 'CARTE_BANCAIRE');
                        formik.setFieldValue('montantPaye', montantTotalTTC);
                      }}
                    />
                    <label className="btn btn-outline-primary w-100 p-3" htmlFor="carte">
                      <div className="text-center">
                        <FaCreditCard size={24} className="mb-2" />
                        <div className="fw-bold">{t('facture.modeReglement.card')}</div>
                        <small className="text-muted">{t('payment.cardDescription')}</small>
                      </div>
                    </label>
                  </div>
                </Col>
              </Row>

              {formik.touched.modePaiement && formik.errors.modePaiement && (
                <div className="invalid-feedback d-block mt-2">{formik.errors.modePaiement}</div>
              )}
            </CardBody>
          </Card>

          {/* Amount Section - Only for Cash */}
          
            <Row>
              <Col md={6}>
                <Card className="border-info border-opacity-25">
                  <CardBody className="p-3">
                    <Label className="fw-semibold text-info mb-2 d-flex align-items-center">
                      <FaMoneyBillWave className="me-2" size={14} />
                      {t('payment.amountReceived')}
                    </Label>
                    <Input
                      type="number"
                      name="montantPaye"
                      value={formik.values.montantPaye}
                      onChange={formik.handleChange}
                      onFocus={(e) => e.target.select()}
                      min={montantTotalTTC}
                      step="0.1"
                      className="form-control-lg text-center fw-bold text-success"
                      style={{ fontSize: '1.2rem' }}
                    />
                  </CardBody>
                </Card>
              </Col>

              <Col md={6}>
                <Card className="border-warning border-opacity-25">
                  <CardBody className="p-3">
                    <Label className="fw-semibold text-warning mb-2 d-flex align-items-center">
                      <FaMoneyBillWave className="me-2" size={14} />
                      {t('payment.change')}
                    </Label>
                    <Input
                      type="text"
                      value={formatPrice((formik.values.montantPaye || montantTotalTTC) - montantTotalTTC)}
                      disabled
                      className="form-control-lg text-center fw-bold bg-light text-success"
                      style={{ fontSize: '1.2rem' }}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          
        </ModalBody>

        <ModalFooter className="border-top-0 bg-light p-3">
          <div className="d-flex w-100 gap-2">
            <Button
              color="secondary"
              onClick={togglePaymentModal}
              className="flex-fill py-2 d-flex align-items-center justify-content-center"
            >
              <FaTimes className="me-2" />
              {t('payment.cancel')}
            </Button>
            <Button
              color="success"
              onClick={() => handleEncaisserCommande(formik.values)}
              disabled={!formik.values.estCadeau && formik.values.montantPaye < montantTotalTTC}
              className="flex-fill py-2 d-flex align-items-center justify-content-center fw-bold"
              style={{ fontSize: '1.05rem' }}
            >
              <FaCheck className="me-2" />
              {t('payment.processPayment')}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </Container >
  );
};

export default CaisseForm;
